import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { i18nTranslationHelper } from '@/i18n'

/**
 * RouteAnnouncer component for announcing route changes to screen readers
 * This improves accessibility for users navigating a Single Page Application
 */
export function RouteAnnouncer() {
  const t = i18nTranslationHelper.getTComponents
  const location = useLocation()
  const announcerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    // Anunciar mudança de rota para leitores de tela
    if (announcerRef.current) {
      const pageTitle = document.title || t('accessibility.defaultPageTitle')
      announcerRef.current.textContent = t('accessibility.routeChange', { pageTitle })
    }
  }, [location, t])

  return (
    <div
      ref={announcerRef}
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="sr-only"
    />
  )
}
